import React from 'react';
import { Translation } from 'react-i18next';
import { reportClientError } from '../utils/reportClientError';

interface ClientErrorBoundaryProps {
  children: React.ReactNode;
}

interface ClientErrorBoundaryState {
  hasError: boolean;
}

export class ClientErrorBoundary extends React.Component<
  ClientErrorBoundaryProps,
  ClientErrorBoundaryState
> {
  state: ClientErrorBoundaryState = {
    hasError: false,
  };

  static getDerivedStateFromError(): ClientErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, errorInfo: React.ErrorInfo): void {
    reportClientError('React render error', error, {
      componentStack: errorInfo.componentStack,
      errorBoundary: 'ClientErrorBoundary',
      source: 'react-error-boundary',
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="auth-tw flex min-h-screen items-center justify-center p-6 text-center text-body-medium-medium text-content">
          <Translation>{t => t('Something went wrong')}</Translation>
        </div>
      );
    }

    return this.props.children;
  }
}
